import { JsonApi } from '@/_type/json'
import { openDialog } from '@/_components/dialog/dialog'
import { isEqual, map } from 'lodash'
import EditorJS from '@/_models/editorJS'

export default class JsonApiObject {
    isJSONApi = true
    public readonly _id: string | null
    public readonly _type: string
    public _relationships: { [key: string]: any } = {}
    protected _links: { [key: string]: string } = {}
    public _constraints: { [key: string]: { [key: string]: any } } = {}

    public constructor(data: JsonApi, included?: Array<any>) {
        this._id = data.id ? data.id : null
        this._type = data.type

        this.initalize(data, included)
    }

    public initalize(data, included?) {
        if (data.attributes) {
            for (let key of Object.keys(data.attributes)) {
                if (key == 'constraints') {
                    this._constraints = data.attributes[key]
                } else if (typeof this[key] == 'boolean') {
                    this[key] = data.attributes[key]
                } else {
                    try {
                        let parsedJson = JSON.parse(data.attributes[key])

                        // if(parsedJson.type == 'editorjs' || parsedJson.type == 'text'){
                        //     this[key] =  new EditorJS(parsedJson)
                        // } else {
                        this[key] = parsedJson

                        // }
                    } catch (e) {
                        this[key] = data.attributes[key]
                    }
                }
            }
        }

        if (data.relationships) {
            for (let key of Object.keys(data.relationships)) {
                if (data.relationships[key].hasOwnProperty('data')) {
                    if (Array.isArray(data.relationships[key].data)) {
                        this._relationships[key] = data.relationships[key].data.map((x) => {
                            return { _id: x.id, _type: x.type }
                        })
                    } else {
                        this._relationships[key] = data.relationships[key].data
                            ? {
                                  _id: data.relationships[key].data.id,
                                  _type: data.relationships[key].data.type,
                              }
                            : null
                    }
                }
            }
        }

        if (!!included && included.length > 0) {
            this.handleRelationships(included)
        }

        this._links = data.links || {}
    }

    handleRelationships(included: Array<JsonApiObject>) {
        for (let key of Object.keys(this._relationships)) {
            if (this._relationships[key]) {
                if (this._relationships[key]._id) {
                    if (!this._relationships[key].isJSONApi) {
                        let res = included.find((item) => {
                            return (
                                this._relationships[key]._id == item._id &&
                                this._relationships[key]._type == item._type
                            )
                        })
                        if (res) {
                            if (Object.keys(res._relationships).length > 0) {
                                res.handleRelationships(included)
                            }
                            this._relationships[key] = res
                        }
                    }
                } else if (Array.isArray(this._relationships[key])) {
                    this._relationships[key] = this._relationships[key].map(
                        (relationship, index) => {
                            if (!relationship.isJSONApi) {
                                let res = included.find((item) => {
                                    return (
                                        relationship._id == item._id &&
                                        relationship._type == item._type
                                    )
                                })

                                if (res) {
                                    if (Object.keys(res._relationships).length > 0) {
                                        res.handleRelationships(included)
                                    }
                                    return res
                                } else {
                                    return relationship
                                }
                            }
                        }
                    )
                }
            } else {
                this._relationships[key] = null
            }
        }
    }

    get avatar() {
        return this['avatarFileId']
            ? `https://attachment.${process.env.VUE_APP_VBIT_API}/files/${this['avatarFileId']}/preview`
            : null
    }

    get preview() {
        return this['fileId']
            ? `https://attachment.${process.env.VUE_APP_VBIT_API}/files/${this['fileId']}/preview`
            : null
    }

    get fileUrl() {
        return this['fileId']
            ? `https://attachment.${process.env.VUE_APP_VBIT_API}/files/${this['fileId']}`
            : null
    }

    static getFileUrl(fileId: string) {
        return `https://attachment.${process.env.VUE_APP_VBIT_API}/files/${fileId}`
    }

    get relData() {
        return { id: this._id, type: this._type }
    }

    async copyURL(url: string) {
        await navigator.clipboard.writeText(url)
    }

    async copyToClipboard(str: string, $event) {
        await navigator.clipboard.writeText(str)
        let el = document.getElementById('vbit')
        if (!el?.classList.contains('copied')) {
            el?.classList.add('copied')
            const node = document.createElement('span')
            node.classList.add('tooltip')
            node.style.top = `${$event.y - 24}px`
            node.style.left = `${$event.x}px`

            node.appendChild(document.createTextNode('Copied'))
            document.getElementById('vbit')?.appendChild(node)

            setTimeout(() => {
                el?.classList.remove('copied')
                document.getElementById('vbit')?.removeChild(node)
            }, 500)
        }
    }

    setBody(val) {
        const attrKey = Object.keys(val).filter((item) => item.match(/^(?!_)[\w]*/gm))
        let attr: any = {}

        attrKey.map((key) => {
            attr[key] = val[key]
        })

        const relKey = Object.keys(val).filter((item) => item.match(/^_[\w]*/gm))
        let rel: any = {}

        relKey.map((key: string) => {
            let parsedKey = key.split('_').pop()
            if (parsedKey) {
                rel[parsedKey] = val[key]

                if (this.isManyToOne(val[key])) {
                    rel[parsedKey] = {
                        data: val[key].map((item) => {
                            return { id: item._id, type: item._type }
                        }),
                    }
                } else {
                    rel[parsedKey] = { data: val[key] ? val[key].relData : null }
                }
            }
        })

        let body =
            attr || rel
                ? {
                      ...(attr && { attributes: attr }),
                      ...(rel && { relationships: rel }),
                  }
                : null

        return body
    }

    formateBody(attributes, relationships) {
        let attr: any = {}
        if (attributes && Object.keys(attributes).length > 0) {
            Object.keys(attributes).map((key) => {
                let attribute = this.formatAttribute(attributes[key])
                attribute !== this[key] ? (attr[key] = attribute) : null
            })
        }
        if (Object.keys(attr).length == 0) attr = null

        let rel: any = {}

        if (relationships && Object.keys(relationships).length > 0) {
            Object.keys(relationships).map((key) => {
                if (this.isManyToOne(relationships[key])) {
                    this.compareManyToOne(relationships[key], this._relationships[key])
                        ? null
                        : (rel[key] = {
                              data: relationships[key].map((item) => {
                                  return { id: item._id, type: item._type }
                              }),
                          })
                } else {
                    this.compareOneToOne(relationships[key], this._relationships[key])
                        ? null
                        : (rel[key] = {
                              data: relationships[key] ? relationships[key].relData : null,
                          })
                }
            })
        }
        if (Object.keys(rel).length == 0) rel = null

        let body =
            attr || rel
                ? {
                      ...(attr && { attributes: attr }),
                      ...(rel && { relationships: rel }),
                  }
                : null

        return body
    }

    formatAttribute(attr) {
        if (typeof attr == 'string') {
            attr = attr ? attr : null
        }
        return attr
    }

    isManyToOne(rel) {
        return Array.isArray(rel) ? true : false
    }

    compareManyToOne(oldVal, newVal) {
        let oldArr = oldVal.map((item) => item._id).sort()
        let newArr = newVal.map((item) => item._id).sort()
        return isEqual(oldArr, newArr)
    }

    compareOneToOne(oldVal, newVal) {
        return oldVal && newVal ? oldVal._id == newVal._id : !oldVal && !newVal ? true : false
    }

    trackChange(newVal) {
        let res = {}
        Object.keys(newVal).map((key) => {
            switch (typeof newVal[key]) {
                case 'string':
                    if (newVal[key] != this[key]) res[key] = newVal[key]
                    break
                case 'boolean':
                    if (newVal[key] != this[key]) res[key] = newVal[key]
                    break
                case 'object': {
                    if (this.isManyToOne(newVal)) {
                        if (!this.compareManyToOne(this[key], newVal[key])) res[key] = newVal[key]
                    } else {
                        if (!this.compareOneToOne(this[key], newVal[key])) res[key] = newVal[key]
                    }
                }
            }
        })
        return res
    }

    public constraints(constraints: string, attribute: string): any {
        return this._constraints &&
            this._constraints[attribute] &&
            this._constraints[attribute].hasOwnProperty(constraints)
            ? this._constraints[attribute][constraints]
            : false
    }

    public authorized(attribute: string): boolean {
        return this._constraints[attribute].hasOwnProperty('authorized')
            ? this._constraints[attribute]['authorized']
            : true
    }

    public writable(attribute: string): boolean {
        return this._constraints &&
            this._constraints[attribute] &&
            this._constraints[attribute].hasOwnProperty('writable')
            ? this._constraints[attribute]['writable']
            : false
    }

    static async openDialog(component, props) {
        return await openDialog(component, props)
    }
}
